import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as Yup from 'yup'

// @material-ui
import { Typography, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { withLang } from '_core/hocs/withLang'
import { useGlobal } from '_core/hooks/useGlobal'
import { phoneRegExp } from '_core/utils/phoneRegExp'
import { withVisitorInfo } from '_core/utils/visitorInfo'
import { FormValidator } from '_core/components/FormValidator'
import { PhoneInput } from '_core/components/PhoneInput'

// style
import { verifyMobileStepPhoneStyle } from './verifyMobileStepPhoneStyle'

const RawVerifyMobileStepPhone = (props) => {
  const { classes, update, isExpired, visitorInfo, getLangString: l } = props

  const {
    request: { queue },
    notify: { enqueueSnackbar },
    config: { API_METHOD, VERIFICATION_TYPE },
  } = useGlobal()

  const [values, setValues] = useState({
    mobile: visitorInfo.info.mobile,
  })

  const getOnChange = field => value => {
    setValues(oldValues => ({
      ...oldValues,
      [field]: value,
    }))
  }

  const onSubmit = async event => {
    event.preventDefault()

    try {
      await queue(API_METHOD.VISITOR_VERIFICATION_START, {
        type: VERIFICATION_TYPE.MOBILE,
        ...values,
      })

      update()
    } catch (error) {
      process.env.NODE_ENV !== 'production' && console.error(error)
      enqueueSnackbar(error.message, { variant: 'error' })
    }
  }

  const fields = {
    mobile: {
      value: values['mobile'],
      label: l('r._.profile.verify.mobile.label.phone'),
      onChange: getOnChange('mobile'),
      getEventData: data => {
        if (typeof data === 'string') {
          return {
            value: data.replace(/[-\s()]/g, ''),
          }
        }

        return {
          target: data.target,
          value: data.target.value.replace(/[-\s()]/g, ''),
        }
      },
      shape: Yup.string(l('r._.profile.verify.mobile.label.phone'))
        .trim()
        .ensure()
        .required('empty')
        .test('isPhone', 'bad', val =>
          phoneRegExp.test(val.replace(/[-\s()]/g, ''))
        ),
    },
  }

  return (
    <form onSubmit={onSubmit} className={classes.root}>
      {isExpired ? (
        <>
          <Typography variant="body2">
            {l('r._.profile.verify.mobile.text.codeexpiredtitle')}
          </Typography>
          <Typography variant="caption" gutterBottom={true}>
            {l('r._.profile.verify.mobile.text.codeexpiredbody')}
          </Typography>
        </>
      ) : null}

      <FormValidator
        fields={fields}
        touchOnInit={true}
        render={({ form, canSubmit }) => (
          <Grid container={true}>
            <Grid item={true} xs={12} sm={8}>
              <PhoneInput
                {...form['mobile']}
                classes={{ flagButton: classes.phoneInputButton }}
              />
            </Grid>

            <Grid item={true} xs={12} sm={4}>
              <Button type="submit" fullWidth={true} disabled={!canSubmit}>
                {l('r._.profile.verify.control.submit')}
              </Button>
            </Grid>
          </Grid>
        )}
      />
    </form>
  )
};

RawVerifyMobileStepPhone.defaultProps = {}

RawVerifyMobileStepPhone.propTypes = {
  // self props
  isExpired: PropTypes.bool,
  update: PropTypes.func.isRequired,

  // withVisitorInfo
  visitorInfo: PropTypes.object.isRequired,

  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const VerifyMobileStepPhone = withVisitorInfo(withLang(
  withStyles(verifyMobileStepPhoneStyle)(RawVerifyMobileStepPhone)
))
